import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-green-50">
      {/* Navigation */}
      <nav className="bg-white/80 backdrop-blur-sm sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <img src="/logo_dark.png" alt="Paribus AI Logo" className="h-8 w-auto" />
              <span className="ml-2 text-xl font-bold text-green-800">Paribus AI</span>
            </div>
            <div className="flex items-center">
              <Link
                to="/auth"
                className="ml-4 px-4 py-2 rounded-md text-sm font-medium text-green-600 hover:text-green-900 transition-colors"
              >
                Log in
              </Link>
              <Link
                to="/auth"
                className="ml-4 px-4 py-2 rounded-md text-sm font-medium text-white bg-green-600 hover:bg-green-700 transition-all hover:shadow-lg transform hover:-translate-y-0.5"
              >
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-green-50 to-white opacity-70"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative">
          <div className="text-center">
            <h1 className="text-5xl tracking-tight font-extrabold text-gray-900 sm:text-6xl md:text-7xl">
              <span className="block bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-600">
                Discover the elegant power of
              </span>
              <span className="block bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-emerald-500 mt-2">
                Paribus AI
              </span>
            </h1>
            <p className="mt-6 max-w-md mx-auto text-lg text-gray-500 sm:text-xl md:mt-8 md:max-w-3xl md:text-2xl">
              Transform your medical record review process with AI-powered chronologies and insights, built specifically for personal injury law.
            </p>
            <div className="mt-8 max-w-md mx-auto sm:flex sm:justify-center md:mt-12">
              <div className="rounded-md shadow">
                <Link
                  to="/auth"
                  className="w-full flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-r from-green-600 to-emerald-500 hover:from-green-700 hover:to-emerald-600 transition-all hover:shadow-lg transform hover:-translate-y-0.5 md:py-5 md:text-lg md:px-12"
                >
                  Start Free Trial
                </Link>
              </div>
              <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
                <a
                  href="#features"
                  className="w-full flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-md text-green-600 bg-white hover:text-green-700 hover:bg-gray-50 transition-all hover:shadow-lg transform hover:-translate-y-0.5 md:py-5 md:text-lg md:px-12"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Preview */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-all duration-300">
          <img src="/paribus chat.jpg" alt="Paribus AI Interface" className="w-full" />
        </div>
      </div>

      {/* Main Features */}
      <div className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-16 lg:grid-cols-3">
            <div className="text-center transform hover:scale-105 transition-all duration-300">
              <div className="h-16 w-16 mx-auto mb-6 bg-green-100 rounded-2xl flex items-center justify-center">
                <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Handle more cases</h3>
              <p className="mt-4 text-gray-500 text-lg">
                Streamline medical document review and chronology creation. Let our AI handle the heavy lifting while you focus on your clients.
              </p>
            </div>
            <div className="text-center transform hover:scale-105 transition-all duration-300">
              <div className="h-16 w-16 mx-auto mb-6 bg-green-100 rounded-2xl flex items-center justify-center">
                <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Focus on what matters</h3>
              <p className="mt-4 text-gray-500 text-lg">
                Spend time where it counts most: with your clients and in the courtroom. Let Paribus handle the document analysis.
              </p>
            </div>
            <div className="text-center transform hover:scale-105 transition-all duration-300">
              <div className="h-16 w-16 mx-auto mb-6 bg-green-100 rounded-2xl flex items-center justify-center">
                <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Don't miss a thing</h3>
              <p className="mt-4 text-gray-500 text-lg">
                Our AI proactively identifies missing documents, red flags, and potential case issues before they become problems.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Security Section */}
      <div className="bg-gradient-to-b from-green-50 to-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <div className="h-20 w-20 mx-auto mb-8 bg-green-100 rounded-full flex items-center justify-center">
              <svg className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6">Rest easy with rock-solid security</h2>
            <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto">
              Your data never leaves our HIPAA-compliant platform. We maintain the highest security standards to protect your sensitive client information.
            </p>
          </div>
        </div>
      </div>

      {/* Trusted By Section */}
      <div className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-center text-3xl font-bold text-gray-900 mb-8">
            Bringing consumer-level quality tech to personal injury
          </h2>
          <p className="text-center text-xl text-gray-500 mb-16">We've built products you know and love</p>
          <div className="grid grid-cols-2 gap-12 md:grid-cols-4 items-center justify-items-center">
            <img src="/Lyft_logo_svg.png" alt="Lyft" className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" />
            <img src="/Coursera_logo_(2020)_svg.png" alt="Coursera" className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" />
            <img src="/tp logo.jpg" alt="TP" className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" />
            <img src="/tribe logo.png" alt="Tribe Capital" className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" />
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-t from-green-50 to-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform hover:scale-[1.02] transition-all duration-300">
            <div className="px-6 py-12 md:p-12 text-center md:text-left md:flex md:items-center md:justify-between">
              <div className="flex-1 flex md:items-center">
                <div className="flex-shrink-0 hidden md:block">
                  <img src="/rg_headshot.jpg" alt="Ryan" className="h-28 w-28 rounded-2xl object-cover mr-8 shadow-lg" />
                </div>
                <div>
                  <h2 className="text-4xl font-extrabold text-gray-900 mb-4">Want to learn more about AI for PI?</h2>
                  <div className="mt-4 flex items-center text-gray-500 text-lg">
                    <span className="text-2xl mr-2">👋</span>
                    <p>I'm passionate about making your firm more competitive using the latest AI. Let's connect!</p>
                  </div>
                  <p className="mt-2 text-gray-500 font-medium">- Ryan</p>
                </div>
              </div>
              <div className="mt-8 md:mt-0 md:ml-8 flex-shrink-0">
                <a
                  href="https://calendly.com/ryan-george-jns/paribus-intro?month=2025-01"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-xl text-white bg-gradient-to-r from-green-600 to-emerald-500 hover:from-green-700 hover:to-emerald-600 transition-all hover:shadow-lg transform hover:-translate-y-0.5"
                >
                  Talk with our Founder →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 